var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(_vm.transform),attrs:{"viewBox":"0 0 7 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.54419 1L6.00006 5L1.54419 9","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }